var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.901978,
    y: 0.701172,
    width: 8.18375,
    height: 7.04,
    rx: 1.5,
    fill: "#086DAB",
    stroke: "#086DAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.46,
    y: 0.701172,
    width: 7.04,
    height: 7.04,
    rx: 1.5,
    fill: "#086DAB",
    stroke: "#086DAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.901978,
    y: 11.2598,
    width: 7.04,
    height: 7.04,
    rx: 1.5,
    fill: "#086DAB",
    stroke: "#086DAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0717 11.6387V17.9863",
    stroke: "#086DAB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1942 14.8066L10.9599 14.8066",
    stroke: "#086DAB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/addNew.b1e820b587f5015d416f34f83cb7fa78.svg";
export { ForwardRef as ReactComponent };